export default __webpack_public_path__ + "static/media/staggeringblow2.caa5ea25.png";